export const generalCarOptions = [
	{ label: '1톤', value: '1t' },
	{ label: '2톤', value: '2t' },
	{ label: '3톤', value: '3t' },
	{ label: '1-2톤', value: '1-2t' },
	{ label: '2-3톤', value: '2-3t' },
	{ label: '1-3톤', value: '1-3t' },
	{ label: '5톤', value: '5t' },
	{ label: '54M', value: '54m' },
	{ label: '58M', value: '58m' },
	{ label: '75M', value: '75m' },
];

export const guljeolCarOptions = [
	{ label: '28M', value: '28m' },
	{ label: '40M', value: '40m' },
	{ label: '60M', value: '60m' },
	{ label: '70M', value: '70m' },
];

export const workDurationOptions = [
	{ label: '1시간', value: '1h' },
	{ label: '2시간', value: '2h' },
	{ label: '반나절', value: '4h' },
	{ label: '하루', value: '1d' },
	{ label: '2일', value: '2d' },
	{ label: '3일', value: '3d' },
	{ label: '월대', value: 'm' },
]

export const carDetailOptions = [
	{ label: "저상", value: "저상" },
	{ label: "단축", value: "단축" },
	{ label: "중축", value: "중축" },
	{ label: "붐대 M 이상", value: "붐대 M 이상" },
	{ label: "전고 M 이하", value: "전고 M 이하" },
];

export const workEtcOptions = [
	{ label: "친절하신분", value: "친절하신분" },
	{ label: "영업금지", value: "영업금지" },
	{ label: "시간예민X", value: "시간예민X" },
	{ label: "1군서류", value: "1군서류" },
	{ label: "개인차주", value: "개인차주" },
	{ label: "거래처", value: "거래처" },
	{ label: "경력자", value: "경력자" },
];

export type Option = {
	label: string;
	value: string
};
